import { useEffect, useRef } from 'react';

const contactItems = [
  {
    icon: 'ri-map-pin-line',
    label: 'Address',
    lines: ['20 ASEN ZLATAREV str.'],
  },
  {
    icon: 'ri-building-2-line',
    label: 'City',
    lines: ['Plovdiv'],
  },
  {
    icon: 'ri-mail-line',
    label: 'ZIP Code',
    lines: ['4000'],
  },
  {
    icon: 'ri-flag-line',
    label: 'Country',
    lines: ['Bulgaria'],
  },
  {
    icon: 'ri-at-line',
    label: 'Email',
    lines: ['info@borvilood.com'],
  },
  {
    icon: 'ri-phone-line',
    label: 'Phone',
    lines: ['+1 629 348 3480'],
  },
];

export default function ContactSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('[data-animate]').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="contact" ref={sectionRef} className="py-32 bg-zinc-950 relative overflow-hidden">
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://public.readdy.ai/ai/img_res/d688211bedc906d95fd58d63ad37a21f.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-zinc-950/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <div
            data-animate
            className="inline-block text-emerald-400 text-xs font-semibold tracking-widest uppercase mb-5 transition-all duration-700"
            style={{ opacity: 0, transform: 'translateY(20px)', fontFamily: "'Inter', sans-serif" }}
          >
            Contact
          </div>
          <h2
            data-animate
            className="text-white font-bold mb-5 leading-tight transition-all duration-700"
            style={{
              opacity: 0,
              transform: 'translateY(20px)',
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              transitionDelay: '120ms',
            }}
          >
            Get in Touch with BORVIL OOD
          </h2>
          <p
            data-animate
            className="text-zinc-400 max-w-lg mx-auto leading-relaxed transition-all duration-700"
            style={{ opacity: 0, transform: 'translateY(20px)', fontFamily: "'Inter', sans-serif", transitionDelay: '240ms' }}
          >
            We're based in Plovdiv, Bulgaria, and always open to conversations about partnerships, press, and collaboration.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {contactItems.map((item, i) => (
            <div
              key={item.label}
              data-animate
              className="bg-zinc-900 border border-zinc-800 rounded-xl p-6 hover:border-emerald-500/40 transition-all duration-500"
              style={{ opacity: 0, transform: 'translateY(24px)', transitionDelay: `${300 + i * 90}ms` }}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-emerald-500/10 border border-emerald-500/20 flex-shrink-0">
                  <i className={`${item.icon} text-emerald-400 text-base`}></i>
                </div>
                <span className="text-zinc-500 text-xs font-semibold tracking-widest uppercase" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {item.label}
                </span>
              </div>
              {item.lines.map((line) => (
                <p key={line} className="text-white font-medium text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {line}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
